/* eslint-disable react/jsx-props-no-spreading,react/no-array-index-key,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Input, DatePicker, Button, Row, Col, Form, Checkbox, Tooltip } from "antd";
import "../../styles/filters-form.less";
import "./InvoiceCreateByPeriod.less";
import pencilIcon from "../../img/edit.svg";
import tickIcon from "../../img/done.svg";
import deleteIcon from "../../img/delete-round.svg";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import addProperty from "../../img/addProperty.svg";
import { handleCreateByPeriod, handleDownloadFile } from "../../store/slices/invoices";
import { crossIcon } from "../../lib/icons";
import Message from "../Message/Message";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_BILLING_ACCOUNTINGSYSTEM_WRITE } from "../../lib/const/permissions";
import ErrorPage from "../ErrorPage/ErrorPage";

const dateFormat = "MM.YYYY";
const emailList = [
  // {
  //   id: 0,
  //   email: "mail1@mail.ru",
  // },
  // {
  //   id: 1,
  //   email: "mail2@mail.ru",
  // },
];

const InvoiceCreateByPeriod = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(true);
  const [emailsFromAuth, setEmailsFromAuth] = useState([]);
  const [editStatus, setEditStatus] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [newEmailValue, setNewEmailValue] = useState("");
  const [fromDate, setFromDate] = useState(moment().subtract(1, "months").startOf("month"));
  const [toDate, setToDate] = useState(moment().subtract(1, "months").endOf("month"));
  const isEditing = (id) => id === editingKey;
  const previousMonth = moment().subtract(1, "months");


  const layoutCol1 = {
    wrapperCol: { span: 12 },
  };

  const styles = {
    buttonIcon: {
      boxShadow: "none",
      border: 0,
    },
  };

  useEffect(() => {
    setEmailsFromAuth(emailList);
  }, [emailList]);

  const editEmail = (rec) => {
    setEditingKey(rec);
    setEditStatus(true);
  };

  const deleteEmail = (rec) => {
    setEmailsFromAuth((prev) => [...prev.slice(0, rec), ...prev.slice(rec + 1)]);
  };

  const onChangeEmailValue = (e) => {
    setNewEmailValue(e.target.value);
  };

  const confirmEditEmail = () => {
    const updatedList =
      emailsFromAuth &&
      emailsFromAuth.map((item) => {
        if (item.id === editingKey) {
          return { ...item, email: newEmailValue };
        }
        return item;
      });

    setEmailsFromAuth(updatedList);
    setEditStatus(false);
  };

  const cancelEditEmail = () => {
    setEditStatus(false);
  };

  const renderUserIcons = (record, key) =>
    editStatus && isEditing(record.id) ? (
      <>
        <Button
          icon={<img src={tickIcon} alt="tick" width="16px" />}
          className="icon"
          type="text"
          htmlType="Button"
          onClick={confirmEditEmail}
          style={styles.buttonIcon}
        />
        <Button
          icon={<img src={deleteIcon} width="16px" alt="delete" />}
          type="text"
          className="icon"
          htmlType="button"
          onClick={cancelEditEmail}
          style={styles.buttonIcon}
        />
      </>
    ) : (
      <>
        <Button
          type="text"
          icon={<img src={pencilIcon} width="14px" alt="pencil" />}
          htmlType="button"
          onClick={() => editEmail(key)}
          style={styles.buttonIcon}
          disabled={editStatus}
        />
        <Button
          type="text"
          icon={<div className="remove-icon">{crossIcon("#CCDDEE")}</div>}
          htmlType="button"
          onClick={() => deleteEmail(key)}
          style={styles.buttonIcon}
          disabled={editStatus}
        />
      </>
    );

  const onFinish = async (values) => {
    const firstDayOfCurrentMonth = moment(values.period).startOf("month");
    const lastDayOfCurrentMonth = moment(values.period).endOf("month");

    const emailsNewCheck = Object.values(values).filter((value) => Array.isArray(value));

    let emailsNewForRequest;
    if (emailsNewCheck.length !== 0)
      emailsNewForRequest = emailsNewCheck[0].map((item) => item.email);
    else emailsNewForRequest = [];

    let emailsFromAuthForRequest;
    if (emailsFromAuth && emailsFromAuth.length !== 0)
      emailsFromAuthForRequest = emailsFromAuth.map((item) => item.email);
    else emailsFromAuthForRequest = [];

    const emailsListForRequest = [...emailsNewForRequest, ...emailsFromAuthForRequest];

    if (emailsListForRequest.length !== 0) {
      dispatch(
        handleCreateByPeriod({
          emails: emailsListForRequest,
          periodFrom: toHttpFormatStartOfDay(firstDayOfCurrentMonth),
          periodTo: toHttpFormatEndOfDay(lastDayOfCurrentMonth),
        })
      );
    } else {
      Message("Список e-mail адресов не заполнен");
    }
  };

  const onChangeDate = (value) => {
    const firstDayOfCurrentMonth = moment(value).startOf("month");
    const lastDayOfCurrentMonth = moment(value).endOf("month");
    setFromDate(firstDayOfCurrentMonth);
    setToDate(lastDayOfCurrentMonth);
  };

  const handleDownload = () => {
    dispatch(
      handleDownloadFile({
        periodFrom: toHttpFormatStartOfDay(fromDate),
        periodTo: toHttpFormatEndOfDay(toDate),
      })
    );
  };

  const validateMessages = {
    required: "Заполните все поля",
    types: {
      email: "Неверный формат почты",
    },
  };

  const onChecked = () => {
    // setChecked(!!e.target.checked);
    setChecked(true);
  };

  return (
    <>
      <h3 className="invoice-period-header">Параметры экспорта данных в 1С</h3>
      <Form
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        validateMessages={validateMessages}
        initialValues={{
          period: previousMonth,
        }}
        form={form}
        autoComplete="off"
      >
        <Row align="top">
          <Col>
            <Form.Item
              label="Расчетный период"
              name="period"
              labelAlign="left"
              rules={[{ required: true }]}
              {...layoutCol1}
            >
              <DatePicker
                allowClear={false}
                picker="month"
                onChange={onChangeDate}
                style={{ minWidth: "140px" }}
                placeholder="Выберите месяц"
                format={dateFormat}
              />
            </Form.Item>
            <Col align="right">
              <Button type="primary" onClick={handleDownload}>
                Сохранить в файл
              </Button>
            </Col>
          </Col>
          <Col span={12} offset={6}>
            <Form.List name="emails">
              {(fields, { add, remove }) => (
                <Col span={14} className="email-block">
                  <div className="email-block-item">
                    <Row align="middle" className="email-block__header">
                      <Col span={2}>
                        <Checkbox
                          className="email-block__checkbox"
                          onChange={onChecked}
                          checked={checked}
                        />
                      </Col>
                      <Col span={20}>Отправить файл по адресам</Col>
                      <Col span={2} style={{ textAlign: "right" }}>
                        <Tooltip title="Добавить почту">
                          <Button
                            className="email-block__send-btn"
                            icon={<img src={addProperty} alt="add property" width="21px" />}
                            type="text"
                            htmlType="button"
                            onClick={() => add()}
                            disabled={editStatus}
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                    <div className="email-list">
                      {emailsFromAuth &&
                        emailsFromAuth.map((item, idx) => (
                          <Row key={idx}>
                            <Col span={20}>
                              <Row align="middle">
                                <Col span={4}>
                                  <label
                                    style={{
                                      color: "#8899AA",
                                    }}
                                  >
                                    E-mail:
                                  </label>
                                </Col>
                                <Col span={20}>
                                  {editStatus && isEditing(item.id) ? (
                                    <Input
                                      onChange={onChangeEmailValue}
                                      defaultValue={item.email}
                                    />
                                  ) : (
                                    <span style={{ color: "#000000" }}>{item.email}</span>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={4} align="right">
                              {renderUserIcons(item, idx)}
                            </Col>
                          </Row>
                        ))}
                      {fields.map((field) => (
                        <Row key={field.key} align="middle">
                          <Col span={20}>
                            <Row align="top">
                              <Col span={4}>
                                <label
                                  style={{
                                    color: "#8899AA",
                                    top: "6px",
                                    position: "relative",
                                  }}
                                >
                                  E-mail:
                                </label>
                              </Col>
                              <Col span={20}>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "email"]}
                                  fieldKey={[field.fieldKey, "email"]}
                                  rules={[
                                    {
                                      required: true,
                                      type: "email",
                                    },
                                  ]}
                                  label=""
                                  labelAlign="left"
                                  style={{ display: "flex", marginBottom: 2 }}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={4} align="right">
                            <Button
                              type="text"
                              icon={<div className="remove-icon">{crossIcon("#CCDDEE")}</div>}
                              htmlType="button"
                              onClick={() => remove(field.name)}
                              style={styles.buttonIcon}
                              disabled={editStatus}
                            />
                          </Col>
                        </Row>
                      ))}
                    </div>
                  </div>
                  <Col align="right">
                    <Button htmlType="submit">Отправить</Button>
                  </Col>
                </Col>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </>
  );

};

export default InvoiceCreateByPeriod;
